import script from "./itemV2ShopTheLook.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV2ShopTheLook.vue?vue&type=script&setup=true&lang=ts"

import "./itemV2ShopTheLook.vue?vue&type=style&index=0&id=2ec37b52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec37b52"]])

export default __exports__